import { ActionTypes } from "../constants";

export default function festivalPortfolio(state = {}, action) {
  switch (action.type) {
    case ActionTypes.SET_AMAZON_GOAL_DATA:
      return Object.assign({}, state, action.payload);
    default:
      return state;
  }
}